import { FormEvent, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { ModelSchemaWidget } from "./components/ModelSchemaWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-extraction-node-configuration";
import {Button} from "@mui/material";

export const WorkflowExtractionNodeConfiguration = () => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog() {
        context.toggleShowExtractionModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {
        extractions: {
            items: {
                'data_input': {
                    'ui:widget': 'NodeDataStoreSelectWidget',
                    'ui:options': {
                        'classNames': 'data-management',
                        enumDisabled: [
                            'hq_params',
                            'scraper_pending'
                        ]
                    }
                },
            }
        },
        'custom_key_value_array_schema': {
            'ui:widget': 'textarea'
        },
        'custom_data_model_schema': {
            'ui:widget': 'ModelSchemaWidget'
        },
        'value_to_inject': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            },
        },
        'data_management': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            },
        },
        'ui:order': [
            'extraction_data_type',
            'custom_key_value_array_schema',
            'custom_data_model_schema',
            'extractions',
            'input_key',
            'data_management',
            'add_output_to_message'
        ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget,
        ModelSchemaWidget: ModelSchemaWidget
    }

    useEffect( () => {
        if (context.activeExtractionNode !== undefined && context.activeExtractionNode.data !== undefined) {
            setFormData(context.activeExtractionNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showExtractionModal }
            title={ "Extraction Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >

            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>
                </div>
            </Form>
        </DefaultFormDialog>
    );
}